import { useState } from "react";
import { Music2 } from "lucide-react";
import { resolveImageUrl, buildSrcSet } from "@/components/ImageUpload";

// Imagen de portada con fallback de marca cuando falta o falla la carga.
export function CoverImage({ src, alt = "", className = "", testid, priority = false, ratio, sizes = "(max-width: 768px) 100vw, 33vw" }) {
  const [err, setErr] = useState(false);
  const url = resolveImageUrl(src);
  // Reserva el espacio intrínseco de la imagen para evitar saltos de layout (CLS).
  const ratioStyle = ratio ? { aspectRatio: ratio } : undefined;
  // Deriva width/height explícitos para que el navegador reserve el espacio antes de cargar
  // la imagen (mejora CLS y cumple la auditoría de Lighthouse). Si no hay ratio, usa un valor
  // por defecto; el tamaño real lo controla el CSS del contenedor (object-cover).
  let wAttr = 1200, hAttr = 1200;
  if (ratio && /^\s*\d+\s*\/\s*\d+\s*$/.test(ratio)) {
    const [rw, rh] = ratio.split("/").map((n) => parseInt(n.trim(), 10));
    if (rw > 0 && rh > 0) { wAttr = rw * 100; hAttr = rh * 100; }
  }
  if (!url || err) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-[#2A00D9] via-[#2400b8] to-[#1E00A0] ${className}`}
        style={ratioStyle}
        data-testid={testid ? `${testid}-fallback` : undefined}
        aria-label={alt}
      >
        <Music2 className="text-[#B4D844]/80" size={40} strokeWidth={1.5} />
      </div>
    );
  }
  const srcSet = buildSrcSet(src, priority);
  return (
    <img
      src={url}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      width={wAttr}
      height={hAttr}
      onError={() => setErr(true)}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      style={ratioStyle}
      className={className}
      data-testid={testid}
    />
  );
}
